import api from '../index'

let header = {
    belong: 'bulletin'
}
export default {

    getApps(){
        return api.get('/portal/app/list', {}, header)
        // return api.get('/appuser/apps', {}, header)
    },

    // 获取用户信息
    getSubsystem() {
        // return api.get('/smartMedia/getSubsystem', {}, header)
        return api.get('/portal/user/info', {}, header)
    },

    getProof(params){
        return api.post('/smartMedia/getProof', params, {
            belong : "home"
        })
    },

    // 最近使用模板
    getRecentlyList(params){
        return api.get('/portal/recently/template',params, header)
    },
    // 公告列表
    getNoticeList(params){
        return api.post('/portal/notice',params, header)
    },
    // 待办列表
    getTodoList(params){
        return api.post('/portal/todo',params, header)
    },
    // 抄送列表
    getCopyList(params){
        return api.post('/portal/copy',params, header)
    },
    // 已发列表
    getSentList(params){
        return api.post('/portal/already/sent',params, header)
    },
    // 消息中心列表
    getMsgList(pageParam, params){
        const { page, limit } = pageParam
        return api.post(`/portal/message/list?page=${page}&limit=${limit}`,params, header)
    },
    // 消息未读数
    getMsgUnread(params){
        return api.get('/portal/message/selectUnreadFloat',params, header)
    },
    // 消息一键已读
    msgUpdate(params){
        return api.post('/portal/message/update',params, header)
    },
    // 每日语录
    getDailyQuot(params){
        return api.get(`/dailyQuotations`,params, header)
    },
    // ios下载
    getDownloadUrl(params){
        return api.get(`/portal/download/url`,params, header)
    },
    // android下载
    getAnroidApkUrl() {
        return api.get('https://young.timesmedia.com.cn/x/app-server/api/system/version/latestVersion', {  sourceType: 1 }, header)
    }
}
